import { debugLog } from '~/debug';

/**
 * Safely set or delete localStorage values. Give null to the 2nd argument to delete from localStorage
 * @param keyName
 * @param value
 * @param windowContext
 */
export function safeLocalStorageSetDelete(keyName: string, value: string | null, windowContext: Window = window) {
  try {
    if (value === null) {
      windowContext.localStorage.removeItem(keyName);
      windowContext.localStorage.removeItem(`${keyName}_duration`);
    } else {
      windowContext.localStorage.setItem(keyName, value);
    }
  } catch (e) {
    debugLog('warn', `Error saving/removing data to/from localStorage  ${keyName}`, e.message);
  }
}

/**
 * Set localStorage key with a duration of n hours
 * @param keyName
 * @param value
 * @param duration
 */
export function safeLocalStorageSetForDuration(keyName: string, value: string, duration: number) {
  const currentMoment = Date.now();
  const durationInMilliseconds = duration * 60 * 60 * 1000;
  safeLocalStorageSetDelete(`${keyName}_duration`, (currentMoment + durationInMilliseconds).toString());
  safeLocalStorageSetDelete(keyName, value);
}

/**
 * Safely get a localStorage value
 * @param keyName
 * @returns
 */
export function safeLocalStorageGet(keyName: string) {
  try {
    /** Check if there's a duration for the key. We need to expire localStorage keys manually as they don't have durations like cookies */
    const durationOfItem = localStorage.getItem(`${keyName}_duration`);
    if (durationOfItem) {
      const currentMoment = Date.now();
      // If past the expiration date - delete and return null, else return the value as it's still fresh
      if (currentMoment > parseInt(durationOfItem)) {
        safeLocalStorageSetDelete(`${keyName}_duration`, null);
        safeLocalStorageSetDelete(keyName, null);
        return null;
      } else {
        return localStorage.getItem(keyName);
      }
    } else {
      return localStorage.getItem(keyName);
    }
  } catch (e) {
    debugLog('warn', `Error getting data from localStorage: ${keyName}`, e.message);
    return null;
  }
}
